











 
















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StartDraggingReflectionMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reflectionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RemoteReflectionDrag",
      "kind": "LinkedField",
      "name": "remoteDrag",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dragUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dragUserName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSpotlight",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StartDraggingReflectionPayload",
  "abstractKey": null
};

(node ).hash = "617f5500e252efe8d7b68bcec2ff9e01";

export default node;
